import React, { useState, useContext } from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText
} from 'reactstrap';
import Logo from "./Image/logo.png"
import {UserContext} from "./UserContext"

const Header = (props) => {
  const [user, setUser] = useContext(UserContext)
  const [isOpen, setIsOpen] = useState(false);
  const handleLogout = ()=>{
    setUser(null)
    localStorage.removeItem("user")
  }
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div>
      <Navbar color="info" dark expand="md">
        <NavbarBrand href="/"><img src={Logo} alt={Logo} width="60px" /></NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
          <NavItem>
              <NavLink href="/">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/movie">Movie</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/games">Games</NavLink>
            </NavItem>
            { user ? 
            <>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Setting
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem>
                <NavItem>
              <NavLink style={{color:"black"}} href="/settingmovie">Setting Movie</NavLink>
            </NavItem>
                </DropdownItem>
                <DropdownItem>
                <NavItem >
              <NavLink style={{color:"black"}} href="/settinggames">Setting Games</NavLink>
            </NavItem>
                </DropdownItem>
                
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
                Welcome, dani
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem>
            <NavItem>
              <NavLink style={{color:"black"}} onClick={handleLogout}>logout</NavLink>
            </NavItem>
            </DropdownItem>
            <DropdownItem>
                <NavItem >
              <NavLink style={{color:"black"}} href="/changepassword">Change Password</NavLink>
            </NavItem>
                </DropdownItem>
            </DropdownMenu>
            </UncontrolledDropdown>
            </>
            :
            <>
            <NavItem style={{border:"1px solid", backgroundColor:"#abdbe3", fontWeight:"bold", marginLeft:"15px"}}>
              <NavLink href="login">Login</NavLink>
            </NavItem>
            <NavItem style={{border:"1px solid", backgroundColor:"#28a745", fontWeight:"bold"}}>
              <NavLink href="register">Register</NavLink>
            </NavItem>
            </>
            }
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default Header;